export * from './edit-intense.component';
